<template>
<div class="chapter">
<div class="inner_page">
<h1>Maurice</h1>
<h1 class="sigil_not_in_toc">And the Bay Mare</h1>
<h2 class="sigil_not_in_toc">&amp; Lost Farm Camp</h2>
<h2 class="sigil_not_in_toc">Henry Herbert Knibbs</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?d7a78d4e